import Shepherd from "shepherd.js";

const tour = new Shepherd.Tour({
  useModalOverlay: true,
  defaultStepOptions: {
    classes: 'shepherd-theme-custom',
    scrollTo: {
      behavior: 'smooth',
      block: 'nearest',
    },
    arrow: true,
    floatingUIOptions: {
      middleware: [{
        name: 'offset',
        options: {},
        fn: ({ y, placement, ...state }) => ({ ...state, y: placement === 'top' ? y - 15 : y + 5 }),
      }]
    },
  },
});

tour.addStep({
  title: 'Welcome to our landing page!',
  text: "This tour will guide you through some of the features we'd like to point out.",
  buttons: [
    {
      text: `<i class="bi bi-chevron-double-left"></i> Prev`,
      disabled: true,
    },
    {
      text: `Next <i class="bi bi-chevron-double-right"></i>`,
      action: tour.next,
    },
    {
      text: "End Tour",
      action: tour.complete,
    },
  ],
});

tour.addStep({
  title: 'Case List',
  text: `Here is where you'll find your submitted cases.`,
  attachTo: {
    element: `[data-tour="second-step"]`,
    on: "top"
  },
  buttons: [
    {
      text: `<i class="bi bi-chevron-double-left"></i> Prev`,
      action: tour.back,
    },
    {
      text: `Next <i class="bi bi-chevron-double-right"></i>`,
      action: tour.next,
    },
    {
      text: "End Tour",
      action: tour.complete,
    },
  ],
});

tour.addStep({
  title: "Case Search",
  text: "If you can not find a Case, use the Search Toolbox",
  attachTo: {
    element: `[data-tour="third-step"]`,
    on: "top"
  },
  buttons: [
    {
      text: `<i class="bi bi-chevron-double-left"></i> Prev`,
      action: tour.back,
    },
    {
      text: `Next <i class="bi bi-chevron-double-right"></i>`,
      action: tour.next,
    },
    {
      text: "End Tour",
      action: tour.complete,
    },
  ],
});

tour.addStep({
  title: "Light Dashboarding",
  text: "Here's some information you might find useful!",
  attachTo: {
    element: `[data-tour="fourth-step"]`,
    on: "bottom"
  },
  buttons: [
    {
      text: `<i class="bi bi-chevron-double-left"></i> Prev`,
      action: tour.back,
    },
    {
      text: `Next <i class="bi bi-chevron-double-right"></i>`,
      action: tour.next,
    },
    {
      text: "End Tour",
      action: tour.complete,
    },
  ],
});

tour.addStep({
  title: "Get Started",
  text: "Click here to submit a new benefits request",
  attachTo: {
    element: `[data-tour="fifth-step"]`,
    on: "bottom"
  },
  buttons: [
    {
      text: `<i class="bi bi-chevron-double-left"></i> Prev`,
      action: tour.back,
    },
    {
      text: `Next <i class="bi bi-chevron-double-right"></i>`,
      action: tour.next,
    },
    {
      text: "End Tour",
      action: tour.complete,
    },
  ],
});

tour.addStep({
  title: "Contact Us",
  text: "If you have questions or need to send documentation, here is our contact information",
  attachTo: {
    element: `[data-tour="sixth-step"]`,
    on: "bottom"
  },
  buttons: [
    {
      text: `<i class="bi bi-chevron-double-left"></i> Prev`,
      action: tour.back,
    },
    {
      text: `Next <i class="bi bi-chevron-double-right"></i>`,
      disabled: true,
    },
    {
      text: "End Tour",
      action: tour.complete,
    },
  ],
});

tour.on('start', () => {
  setTimeout(() => {
    const overlay = document.querySelector('.shepherd-modal-overlay-container');
    if (!overlay) return;

    const handleWheel = (e: WheelEvent) => {
      const scrollTarget = document.querySelector('.cases-page') as HTMLElement | null;
      if (scrollTarget) {
        scrollTarget.scrollBy({ top: e.deltaY });
        e.preventDefault();
      }
    };

    overlay.addEventListener('wheel', handleWheel as EventListener, { passive: false });
  }, 300)
});

export default tour;
